export default "__VITE_ASSET__BvTNfigI__"